import { render } from "./view-product.vue?vue&type=template&id=2e697736"
import script from "./view-product.vue?vue&type=script&lang=js"
export * from "./view-product.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__